/** * * Asynchronously loads the component for
FamilyPlans
* */ import { lazyLoad } from "utils/loadable";
export const FamilyPlans = lazyLoad(
  () => import("./index"),
  (module) => module.FamilyPlans
);
